export const plansSelector = state => state.subscriptions.allSubscriptionsPlans;
export const currencySelector = state => state.subscriptions.currency;
